import { render, staticRenderFns } from "./DeleteMainGrouperDialog.vue?vue&type=template&id=412c9dc2"
import script from "./DeleteMainGrouperDialog.vue?vue&type=script&lang=ts"
export * from "./DeleteMainGrouperDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports